"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcOffCanvasBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var default_behavior_1 = require("../../../common/models/default-behavior");
var bc_off_canvas_constants_1 = require("./bc-off-canvas-constants");
var bc_off_canvas_constants_2 = require("./bc-off-canvas-constants");
var bc_off_canvas_constants_3 = require("./bc-off-canvas-constants");
var bc_off_canvas_constants_4 = require("./bc-off-canvas-constants");
var bc_off_canvas_constants_5 = require("./bc-off-canvas-constants");
var bc_off_canvas_constants_6 = require("./bc-off-canvas-constants");
var bc_date_constants_1 = require("../../organisms/bc-calendar/bc-date-constants");
var bc_menu_v2_constants_1 = require("../../organisms/bc-menu-v2/bc-menu-v2-constants");
var bc_abstract_dropdown_constants_1 = require("../bc-dropdown/bc-abstract-dropdown-constants");
var helpers_1 = require("../../../common/helpers");
var BcOffCanvasBehavior = (function (_super) {
    __extends(BcOffCanvasBehavior, _super);
    function BcOffCanvasBehavior() {
        return _super.call(this) || this;
    }
    BcOffCanvasBehavior.setUpAll = function () {
        var offCanvasElements = Array.from(document.querySelectorAll("section[class~='".concat(bc_off_canvas_constants_2.OFF_CANVAS, "']")));
        var elements = [];
        for (var _i = 0, offCanvasElements_1 = offCanvasElements; _i < offCanvasElements_1.length; _i++) {
            var offCanvasElement = offCanvasElements_1[_i];
            var element = offCanvasElement;
            var bc = new BcOffCanvasBehavior();
            bc.setElement(element);
            bc.setUp();
            elements.push(bc);
        }
        return elements;
    };
    BcOffCanvasBehavior.prototype._setUp = function () {
        this.configCloseButton();
        this.closeAccesibilidad();
        this.closeOffCanvasWithclick();
        this.closeEventKey();
        this.trapFocus();
        this.verifyInputDate(this.isSafari(), this.getBreakpoint(window.innerWidth) === common_constants_1.BcCommonConstants.MOBILE);
    };
    BcOffCanvasBehavior.prototype.closeOffCanvasWithclick = function () {
        var _this = this;
        this.mySelf.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function (event) {
            if (event.target.className === bc_off_canvas_constants_2.OFF_CANVAS) {
                _this.close();
            }
        });
    };
    BcOffCanvasBehavior.prototype.closeEventKey = function () {
        var _this = this;
        window.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === common_constants_1.BcCommonConstants.KEY_EVENT_ESCAPE) {
                _this.close();
            }
        });
    };
    BcOffCanvasBehavior.prototype.open = function () {
        this.changeStatus(bc_off_canvas_constants_1.OffCanvasStatus.open);
        var aside = this.mySelf.querySelector(bc_off_canvas_constants_1.OFF_CANVAS_SELECTOR_ASIDE);
        aside.focus();
    };
    BcOffCanvasBehavior.prototype.close = function () {
        this.changeStatus(bc_off_canvas_constants_1.OffCanvasStatus.close);
        this.onCloseFunction && this.onCloseFunction();
    };
    BcOffCanvasBehavior.prototype.configCloseButton = function () {
        var _this = this;
        var closeButton = this.mySelf.querySelector("".concat(bc_off_canvas_constants_3.OFF_CANVAS_BUTTONS_QUERY));
        closeButton === null || closeButton === void 0 ? void 0 : closeButton.addEventListener(common_constants_1.BcCommonConstants.EVENT_CLICK, function () {
            _this.close();
        });
    };
    BcOffCanvasBehavior.prototype.onClose = function (fn) {
        this.onCloseFunction = fn;
    };
    BcOffCanvasBehavior.prototype.closeAccesibilidad = function () {
        var closeButton = this.mySelf.querySelector("".concat(bc_off_canvas_constants_3.OFF_CANVAS_BUTTONS_QUERY));
        (0, helpers_1.addFocusable)(closeButton, { tabindex: '0' });
    };
    BcOffCanvasBehavior.prototype.changeStatus = function (status) {
        this.mySelf.setAttribute(bc_off_canvas_constants_4.OFF_CANVAS_STATUS_PROPERTY, status);
    };
    BcOffCanvasBehavior.prototype.trapFocus = function () {
        var aside = this.mySelf.querySelector(bc_off_canvas_constants_1.OFF_CANVAS_SELECTOR_ASIDE);
        var focusableElements = Array.from(aside.querySelectorAll('[tabindex = "0"]'));
        aside.addEventListener(common_constants_1.BcCommonConstants.EVENT_KEY_DOWN, function (event) {
            if (event.key === bc_off_canvas_constants_1.OFF_CANVAS_TAB) {
                var currentElement = document.activeElement;
                var nextElement = focusableElements[(focusableElements.indexOf(currentElement) + common_constants_1.COMMON_CONSTANTS_NUMBERS.N1) % focusableElements.length];
                nextElement.focus();
                event.preventDefault();
            }
        });
    };
    BcOffCanvasBehavior.prototype.isSafari = function () {
        return bc_off_canvas_constants_5.BC_OFF_CANVAS_SAFARI_REGEX.test(navigator.userAgent);
    };
    BcOffCanvasBehavior.prototype.verifyInputDate = function (isSafari, mobile) {
        if (isSafari && mobile) {
            var inputDateRange = Array.from(this.mySelf.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.RANGE_MOLECULE_CLASSES)));
            var inputDate = Array.from(this.mySelf.querySelectorAll(".".concat(bc_date_constants_1.BcDateConstants.DATE_INPUT_DATE_CLASS)));
            inputDateRange.forEach(function (input) {
                var elementResult = input.querySelector(".".concat(bc_abstract_dropdown_constants_1._DROPDOWN_CONTENT_CLASS));
                elementResult.style.overflowY = bc_off_canvas_constants_6.VISIBLE_OVERFLOW;
                var elementResultFixed = input.querySelector(".".concat(bc_date_constants_1.BcDateConstants.FIXED_CONTENT_CLASS));
                elementResultFixed.style.overflow = bc_off_canvas_constants_6.VISIBLE_OVERFLOW;
            });
            inputDate.forEach(function (input) {
                var elementResult = input.querySelector(".".concat(bc_abstract_dropdown_constants_1._DROPDOWN_CONTENT_CLASS));
                elementResult.style.overflowY = bc_off_canvas_constants_6.VISIBLE_OVERFLOW;
            });
        }
    };
    BcOffCanvasBehavior.prototype.getBreakpoint = function (width) {
        if (width <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N767) {
            return common_constants_1.BcCommonConstants.MOBILE;
        }
        else if (width <= bc_menu_v2_constants_1.BcMenuV2Constansts.BC_MENU_V2_N991) {
            return common_constants_1.BcCommonConstants.TABLET;
        }
        else {
            return common_constants_1.BcCommonConstants.DESKTOP;
        }
    };
    return BcOffCanvasBehavior;
}(default_behavior_1.BcDefaultBehavior));
exports.BcOffCanvasBehavior = BcOffCanvasBehavior;
